import {PreferencesList} from "@/interfaces/preference";
import {Grid} from "./grid-helper";
import {getLocaleText} from "@/utils/grid/grid-fr";
import moment from "moment";
import {documentApiProvider} from "@/providers/document-api-provider";
import {MessageType} from "@/components/_shared/template/app-snackbar.vue";
import { i18n } from "@/main";

export abstract class MainGedGrid extends Grid {
  $refs: {
    config: HTMLFormElement;
  };

  defaultPreference = {
    slug: PreferencesList.document,
    columns: [
      "name",
      "type.name",
      "createdAt",
    ],
  };

  gridOptions: any = {
    getRowNodeId: (data: any) => data.id,
    rowHeight: 30,
    localeText: getLocaleText(),
    suppressCellSelection: true,
    suppressMenuHide: true,
    suppressDragLeaveHidesColumns: true,
    blockLoadDebounceMillis: 500,
  };

  getGridField(): object[] {
    return [
      {
        headerName: this.$t("document.name"),
        field: "name",
        sortable: true,
        filterFramework: null,
        resizable: true,
        cellClass: "cell-align-left",
        cellRenderer: function (params: any) {
          if (params.value) {
            return `<span class="text-decoration-underline" style="cursor: pointer;">${params.value}</span>`
          }

          return '';
        }
      }, {
        headerName: this.$t("document.doc_type"),
        field: "type.name",
        sortable: false,
        filterFramework: null,
        resizable: true,
        cellClass: "cell-align-left",
      }, {
        headerName: this.$t("document.date"),
        field: "createdAt",
        sortable: true,
        filterFramework: null,
        resizable: true,
        cellClass: "cell-align-left",
        valueFormatter: function (params: any) {
          if (params.data && params.data.createdAt) {
            return moment(params.data?.createdAt).format("L LT");
          } else {
            return "-";
          }
        },
      },
    ]
  };

  getActionField(): object[] {
    return {
      width: 100,
      minWidth: 100,
      maxWidth: 100,
      sortable: false,
      filterFramework: null,
      resizable: false,
      pinned: "right",
      cellRendererFramework: "GridIconRowComponent",
      cellClass: "cell-align-company",
      valueGetter(params: any) {
        return { id: params.data?.id, active: [true, true] };
      },
      cellRendererParams: {
        icons: [
          { icon: "mdi-pen", event: "open-document-form-modal" },
          { icon: "mdi-delete-outline", event: "remove-document", color: "kDartessRed" }
        ]
      },
    }
  };

  async onCellClicked(event) {
    if (event.column.colId === 'name') {
      await documentApiProvider.downloadPdf(`${event.data.location}`, event.data.name);
    }
  }

  async deleteDocument(doc: any) {
    try {
      const res = await documentApiProvider.delete(`/documents/${doc.id}`);
      this.$eventHub.$emit("show-snackbar", {
        type: MessageType.success,
        mainText: res.success,
        timeout: 3000
      });

      // Update documents list
      this.$emit('update:documents', true)
    } catch (e) {
      this.$eventHub.$emit("show-snackbar", {
        type: MessageType.error,
        mainText: i18n.t('document.delete_error'),
        timeout: 3000
      });
    }
  }
}
